import React, { useEffect, useState } from 'react';
import { Avatar, Box } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import modulosService from '../../services/modulosService';

interface ModuloLogoProps {
  campo: string;
  tieneLogo: boolean;
  logoVersion?: string | null;
  icon: SvgIconComponent;
  color: string;
  size?: number;
}

const ModuloLogo: React.FC<ModuloLogoProps> = ({
  campo,
  tieneLogo,
  logoVersion,
  icon: Icon,
  color,
  size = 56,
}) => {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    let activeUrl: string | null = null;

    if (!tieneLogo) {
      setObjectUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return null;
      });
      return undefined;
    }

    modulosService.fetchLogoObjectUrl(campo, logoVersion).then((url) => {
      if (cancelled) {
        if (url) URL.revokeObjectURL(url);
        return;
      }
      activeUrl = url;
      setObjectUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return url;
      });
    });

    return () => {
      cancelled = true;
      if (activeUrl) URL.revokeObjectURL(activeUrl);
    };
  }, [campo, tieneLogo, logoVersion]);

  if (tieneLogo && objectUrl) {
    return (
      <Box
        component="img"
        src={objectUrl}
        alt=""
        sx={{
          width: size,
          height: size,
          objectFit: 'contain',
          borderRadius: 2,
          bgcolor: '#f5f5f5',
          p: 0.5,
        }}
      />
    );
  }

  return (
    <Avatar
      variant="rounded"
      sx={{
        width: size,
        height: size,
        bgcolor: color,
        borderRadius: 2,
      }}
    >
      <Icon sx={{ fontSize: size * 0.5, color: '#fff' }} />
    </Avatar>
  );
};

export default ModuloLogo;
